export class CreatedByModel {

    public createdOn?: Date;

    public updatedOn?: Date;

    public createdById?: number;

    public updatedById?: number;

    constructor(createdOn?: Date, updatedOn?: Date, createdById?: number, updatedById?: number) {

        this.createdOn = createdOn;
        this.updatedOn = updatedOn;
        this.createdById = createdById;
        this.updatedById = updatedById;
    }
}
